import React from 'react';

interface NPCDialogProps {
  npcId: string;
  currentMessage: string;
  messageIndex: number;
  totalMessages: number;
  onNext: () => void;
  onClose: () => void;
}

const NPCDialog: React.FC<NPCDialogProps> = ({
  npcId,
  currentMessage,
  messageIndex,
  totalMessages,
  onNext,
  onClose,
}) => {
  const hasMoreMessages = messageIndex < totalMessages - 1;

  return (
    <div 
      className="unity-modal-overlay absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
      onClick={onClose}
      style={{ zIndex: 10003 }}
    >
      <div 
        className="relative bg-gray-900 border-2 border-cyan-500 rounded-lg p-6 max-w-xl mx-4 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 w-8 h-8 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors flex items-center justify-center text-lg font-bold"
        >
          ×
        </button>

        {/* NPC Header */}
        <div className="mb-4">
          <h3 className="text-xl font-bold text-cyan-400">
            Intersect Staff Member
          </h3>
        </div>

        {/* Message */}
        <div className="bg-gray-800 border border-gray-700 rounded-lg p-4 mb-4">
          <p className="text-white text-lg leading-relaxed">
            {currentMessage}
          </p>
        </div>

        {/* Progress indicator */}
        {totalMessages > 1 && (
          <div className="flex items-center justify-center gap-2 mb-4">
            {Array.from({ length: totalMessages }).map((_, index) => (
              <div
                key={index}
                className={`h-2 rounded-full transition-all ${
                  index === messageIndex
                    ? 'w-8 bg-cyan-500'
                    : index < messageIndex
                    ? 'w-2 bg-cyan-700'
                    : 'w-2 bg-gray-600'
                }`}
              />
            ))}
          </div>
        )}

        {/* Action buttons */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors"
          >
            Dismiss
          </button>
          {hasMoreMessages && (
            <button
              onClick={onNext}
              className="px-6 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition-colors font-semibold"
            >
              Continue →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NPCDialog;

